import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import RouteTransition from "@/components/RouteTransition";
import { SoundProvider } from "@/components/SoundContext";
import Home from "@/pages/Home";
import About from "@/pages/About";
import FindAJob from "@/pages/FindAJob";
import FindACandidate from "@/pages/FindACandidate";
import Help from "@/pages/Help";
import Contact from "@/pages/Contact";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Brand from "@/pages/Brand";
import BlogPost from "@/pages/BlogPost";

function App() {
  return (
    <div className="App min-h-screen bg-cream text-ink">
      <SoundProvider>
        <BrowserRouter>
          <ScrollToTop />
          <RouteTransition />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/find-a-job" element={<FindAJob />} />
              <Route path="/find-a-candidate" element={<FindACandidate />} />
              <Route path="/help" element={<Help />} />
              <Route path="/help/:slug" element={<BlogPost />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/brand" element={<Brand />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
      </SoundProvider>
    </div>
  );
}

export default App;
